import * as React from 'react';
import { bool, string, object } from 'prop-types';
import styled from 'styled-components';
import media from './fpp_media_queries';
import ImageComponent from './image_component';
import { addItemcode } from '../../Shared/add_to_cart';
import { recordAddToCart } from '../../product_analytics';

import constants from '@core-ds/primitives';
import {
   Button,
   Flex,
   NumberDecrementStepper,
   NumberIncrementStepper,
   NumberInput,
   NumberInputField,
   NumberInputStepper,
} from '@chakra-ui/react';

const { color, fontSize, space } = constants;

const addToCart = (itemcode, option, quantity) => {
   addItemcode(itemcode, quantity);
   recordAddToCart(option, quantity);
};

const AddToCartContainer = styled.div({
   display: 'flex',
   boxShadow: `0 2px 10px ${color.gray2},
               0 7px 60px ${color.gray1}`,
   cursor: 'default',

   [media.mobileLandscapeAll]: {
      flexDirection: 'column',
      maxWidth: 360,
      margin: '0 auto',
   },
});

const ImageContainer = styled.div({
   padding: '40px 30px',
   minWidth: 1,

   [media.mobileLandscapeAll]: {
      paddingBottom: 0,
      minHeight: 1,
   },
});

const TextContainer = styled.div({
   display: 'flex',
   flexDirection: 'column',
   alignItems: 'center',
   justifyContent: 'center',
   padding: '30px 0',
   backgroundColor: color.gray1,
   minWidth: 320,

   [media.mobileLandscapeAll]: {
      minWidth: 'auto',
   },
});

const ProductTitle = styled.h3({
   fontSize: fontSize[5],
   fontWeight: 400,
   margin: 0,
   marginBottom: space[1],
   color: color.gray8,
   textAlign: 'center',
   maxWidth: '100%',

   [media.mobileLandscapeAll]: {
      fontSize: fontSize[4],
      marginBottom: space[0],
   },
});

const ProductPrice = styled.span({
   fontSize: fontSize[3],
   marginBottom: space[5],
   color: color.gray6,

   [media.mobileLandscapeAll]: {
      fontSize: fontSize[2],
      marginBottom: space[4],
   },
});

const AddToCartComponent = ({ itemcode, option, title, price, inStock, productImage }) => {
   const [quantity, setQuantity] = React.useState(1);

   return (
      <AddToCartContainer>
         <ImageContainer>
            <ImageComponent {...productImage} />
         </ImageContainer>

         <TextContainer>
            <ProductTitle>{title}</ProductTitle>
            <ProductPrice>{price}</ProductPrice>

            <Flex
               justifyContent="center"
               alignItems="center"
               paddingLeft="10px"
               paddingRight="10px"
            >
               <Button
                  className="js-add-to-cart-button fpp-add-to-cart-component"
                  colorScheme="blue"
                  size="lg"
                  variant="solid"
                  isDisabled={!inStock}
                  onClick={() => inStock && addToCart(itemcode, option, quantity)}
               >
                  {inStock ? _js('Add to Cart') : _js('Out of Stock')}
               </Button>
               <NumberInput
                  size="lg"
                  maxWidth="25%"
                  paddingLeft="10px"
                  defaultValue={1}
                  min={1}
                  onChange={v => setQuantity(v)}
                  className="fpp-add-to-cart-quantity"
               >
                  <NumberInputField paddingLeft="10px" />
                  <NumberInputStepper>
                     <NumberIncrementStepper className="fpp-add-to-cart-increment" />
                     <NumberDecrementStepper className="fpp-add-to-cart-decrement" />
                  </NumberInputStepper>
               </NumberInput>
            </Flex>
         </TextContainer>
      </AddToCartContainer>
   );
};

AddToCartComponent.propTypes = {
   itemcode: string.isRequired,
   option: object.isRequired,
   title: string,
   price: string,
   inStock: bool,
   productImage: object,
};

AddToCartComponent.defaultProps = {
   title: '',
   price: '',
   inStock: true,
   productImage: null,
};

export default AddToCartComponent;
